<div class='container-tab uploaded-file-tab' #container>
  <form class="form-container" *ngIf="{ isMawChrome: selectedLauncher | isMawChromeLauncher } as launcher">
    <ng-container *ngFor="let source of playlistItem.PlaylistItemLinks; let i = index">
      <div class="row no-gutters source-panel">
        <div class="content-wrapper">
          <div *ngIf="launcher.isMawChrome" class="monitor-index url" matTooltip="Add switch item"
            (click)="addSwitchItem(i)">
            <span>{{ i + 1 }}</span>
            <mat-icon svgIcon="splitscreen_add"></mat-icon>
          </div>
          <ng-container *ngIf="!source.IsFile; else fileInput">
            <div class="title-input-wrapper flex-fill" [class.android]="playlist.IsAndroid">
              <input #url class="title-input" placeholder="http://" id="URL{{i}}" name="URL{{i}}"
                [(ngModel)]="source.Link" (input)="onSourceChanged($event, i, playlistItem)">
            </div>
            <mat-icon *ngIf="i > 0" class="ctrl-icon" (click)="onChangeField(playlistItem, i)" svgIcon="image" matTooltip="Add file">
            </mat-icon>
          </ng-container>

          <ng-template #fileInput>
            <div class="title-input-wrapper file-input flex-fill">
              <select class="url-tab" [(ngModel)]="source.FileId" name="file{{i}}" (change)="onSourceChanged($event, i, playlistItem)">
                <ng-container *ngIf="recentFiles$ | async as files; else loadingFiles">
                  <option class="d-none" selected [value]="source.FileId">Select a file</option>
                  <option *ngFor="let file of files" [ngValue]="file.Id">
                    {{ file.Title }}
                  </option>
                  <option *ngIf="!files || !files?.length" disabled>There are no files</option>
                </ng-container>

                <ng-template #loadingFiles>
                  <option class="d-none" disabled selected [value]="source.FileId">Loading...</option>
                </ng-template>
              </select>
            </div>
            <div class="d-flex align-items-center ml-auto">
              <label class="mb-0">
                <input class="d-none" type="file" ngFileSelect [options]="options" (uploadOutput)="onUploadFile($event, i)"
                  [uploadInput]="uploadInput">
                    <mat-icon class="ctrl-icon" svgIcon="upload" matTooltip="Upload a new file">
                    </mat-icon>
              </label>
              <mat-icon class="ml-2 ctrl-icon" (click)="onChangeField(playlistItem, i)" svgIcon="url_small" matTooltip="Add url"></mat-icon>
            </div>
          </ng-template>

          @if (source.File || source.Link) {
            <div class="settings-wrapper" [ngClass]="{ 'ml-auto': i === 0 }">
              @if (!source.IsFile && source.Link && !source.InnerItemLinks?.length) {
                <div class="refresh-interval-wrapper">
                  <time-input [(value)]="source.RefreshInterval" matTooltip="Refresh interval"></time-input>
                </div>
              }

              <zoom-input *ngIf="source.File || source.Link" class="m-0"
                [source]="source" [item]="playlistItem"></zoom-input>
            </div>
          }
        </div>

        @for (innerSource of source.InnerItemLinks; track $index) {
          <mat-divider class="inner-link-divider"></mat-divider>

          <div class="content-wrapper">
            <div class="title-input-wrapper inner-input flex-fill">
              <input class="title-input" placeholder="http://" name="innerURL{{ i.toString() + $index.toString() }}"
                [(ngModel)]="innerSource.Link">
            </div>

            @if (innerSource.Link) {
              <zoom-input class="m-0" [source]="innerSource" [item]="playlistItem"></zoom-input>
            }

            <div class="d-flex align-items-center">
              <mat-icon (click)="removeSwitchItem(i, $index)" class="remove-icon gray"
                 svgIcon="close" matTooltip="Remove item"></mat-icon>
            </div>
          </div>
        }

        @if (source.InnerItemLinks?.length) {
          <div class="inner-items-duration-wrapper">
            <label for="switchInterval" class="mb-0">Time spent on each item</label>
            <div class="invisible-border duration-wrapper position-relative" id="switchInterval">
              <duration-picker [(duration)]="source.InnerItemDuration" [tooltip]="'Change interval'">
              </duration-picker>
            </div>
          </div>
        }
      </div>

      <ng-container *ngIf="playlistItem.PlaylistItemLinks.length > 1 || source.InnerItemLinks?.length">
        <mat-divider *ngIf="!source.IsFile || !source.percentage; else progressBar"></mat-divider>
      </ng-container>

      <ng-template #progressBar>
        <mat-progress-bar [mode]="'determinate'" [value]="source.percentage"></mat-progress-bar>
      </ng-template>
    </ng-container>

    <app-launcher-features [launcherFeatures]="playlistItem.launcherFeatures"></app-launcher-features>

    <div *ngIf="selectedLauncher?.IsFullScreen" class="row no-gutters">
      <div class="col-md-3">
        <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.OpenInFullScreen" name="OpenInFullScreen"
          class="light" matTooltip="Playlist item will be opened in full screen">
          Open in Full Screen
        </mat-checkbox>
      </div>
    </div>

    <div class="form-group row invisible-border" *ngIf="playlistItem.PlaylistItemLinks.length > 1">
      <label for="Name" class="col-md-3" matTooltip="Playlist item name">Name</label>
      <input type="text" class="col-md-5" placeholder="Playlist item name" [(ngModel)]="playlistItemName" id="Name"
        name="Name">
    </div>

    <div class="form-group row no-gutters invisible-border" *ngIf="!playlist.IsAndroid">
      <label for="OpenWith" class="col-md-3" matTooltip="Application which will play a playlist item">Open
        With...</label>
      <mat-select class="col-md-5 pr-0" id="OpenWith" [(ngModel)]="selectedLauncher" name="launcher" panelClass="launcher-select"
        placeholder="Default Apps" (selectionChange)="onLauncherChanged($event.value)" [disableOptionCentering]="true">
        <mat-select-trigger>
          <img *ngIf="selectedLauncher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + selectedLauncher.LauncherImage"/>
          <ng-template #icon>
            <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
          </ng-template>
          <span>{{ selectedLauncher?.LauncherTitle }}
            <ng-container *ngIf="selectedLauncher?.LauncherDescription">
              ({{ selectedLauncher.LauncherDescription }})
            </ng-container>
          </span>
        </mat-select-trigger>
        <mat-option value="image" *ngFor="let launcher of launchers | launcherSort" [value]="launcher">
          <img *ngIf="launcher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + launcher.LauncherImage"/>
          <ng-template #icon>
            <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
          </ng-template>
          <span>{{ launcher.LauncherTitle }}
            <ng-container *ngIf="launcher.LauncherDescription">
              ({{ launcher.LauncherDescription }})
            </ng-container>
          </span>
        </mat-option>
        <mat-option *ngIf="!launchers || !launchers.length" disabled>There are no
          {{ playlist.MachinePhysicalAddress ? 'local' : 'common'}} launchers</mat-option>
      </mat-select>

      <mcl-mode-select *ngIf="launcher.isMawChrome" [item]="playlistItem" [parentContainer]="container"
        [rss]="playlistItem.RssConfigs" (changeMode)="onChangeMCLMode(playlistItem, $event)">
      </mcl-mode-select>
    </div>

    <div class="form-group row">
      <label for="Duration" class="col-md-3" matTooltip="Playlist item duration">Set Duration</label>
      <div class="col-md-5 invisible-border duration-wrapper">
        <duration-picker [(duration)]="playlistItem.Duration" (dateTimeChanged)="playlistItem.useExactDuration = false">
        </duration-picker>
      </div>
    </div>

    @if (launcher.isMawChrome || !hasRssForegroundItem) {
      <rss-source [playlist]="playlist" [playlistItem]="playlistItem"></rss-source>
    }

    <div class="form-group row invisible-border" *ngIf="!launcher.isMawChrome">
      <label for="CustomParameters" class="col-md-3" matTooltip="Parameters for a playlist item">Custom
        Parameters</label>
      <input type="text" class="col-md-5" [(ngModel)]="playlistItem.CustomParameters" id="CustomParameters"
        name="CustomParameters">
    </div>

    <ng-container *ngIf="launcher.isMawChrome">
      <div class="row no-gutters mt-4 mb-1" *ngIf="playlistItem.ExactVideoDuration">
        <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.useExactDuration"
          (change)="onExactDurationChange($event.checked)" name="UseExactDuration" class="light"
          matTooltip="Exact duration for a playlist item">Use Exact Duration
        </mat-checkbox>
      </div>

      <div class="row mb-1" [ngClass]="{'mt-4': !playlistItem.ExactVideoDuration}">
        <div class="col-md-3">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsMuted" name="IsMuted"
            class="light" matTooltip="Item will be muted">
            Mute
          </mat-checkbox>
        </div>
      </div>

      <div class="row no-gutters mb-1">
        <div class="col-md-3">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsContentStretched" name="IsContentStretched"
            class="light" matTooltip="Item content will be stretched" (change)="onStretchContentChanged(playlistItem)">
            Stretch content
          </mat-checkbox>
        </div>
      </div>

      <div class="row no-gutters mb-1">
        <div class="col-md-3">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IncognitoMode" name="IncognitoMode"
            class="light" matTooltip="Runs URL in incognito mode">
            Incognito mode
          </mat-checkbox>
        </div>
      </div>

      <div class="row no-gutters mb-3">
        <div class="col-md-3">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.SkipIfNoInternet" name="SkipIfNoInternet"
            class="light" matTooltip="Item will be skipped with no internet connection">
            Skip if there is no Internet connection
          </mat-checkbox>
        </div>
      </div>
    </ng-container>

    <div class="row no-gutters mt-4" *ngIf="playlist.IsAndroid">
      <playlist-item-advanced-options [item]="playlistItem"></playlist-item-advanced-options>
    </div>
  </form>

  <mat-toolbar class="tab-footer unset">
    <mat-checkbox *ngIf="!playlistItem.Id" [disableRipple]="true" [(ngModel)]="addAnother" name="addAnother"
      class="light" matTooltip="Add one more item to the Playlist">Add Another</mat-checkbox>

    <button type="button" mat-raised-button (click)="cancel()" mat-flat-button matTooltip="Cancel">Cancel</button>
    <button type="submit" (click)="submit()"
      [disabled]="!playlistItem.PlaylistItemLinks[0].Link && !(playlistItem.PlaylistItemLinks.length > 1)"
      mat-flat-button matTooltip="Save">Save</button>
  </mat-toolbar>
</div>
